

import { useEffect, useState } from "react";

import liff from "@line/liff";
import { CURRENT_ENV } from "../../Utills/constants";
import axios from "axios";
import LoadingScreen from "../Loading/LoadingScreen";
import game from "../../Images/gacha1.png";
import { useSearchParams } from "react-router-dom";
import { message } from 'antd';
import confetti from "canvas-confetti";

function Theme1Screen() {
  const [searchParams] = useSearchParams();
  const [messageApi, contextHolder] = message.useMessage();

  const [profileLine, setProfileLine] = useState(null);
  const [canPlay, setCanPlay] = useState(null);
  const [listRewards, setListRewards] = useState(null);
  const [rewards, setRewards] = useState(null);

  const [isShaking, setIsShaking] = useState(false);

  const [loading, setLoading] = useState(true);

  const [code, setCode] = useState(searchParams.get("gcode") || "");

  const success = (text) => {
    messageApi.open({
      type: 'success',
      content: text,
    });
  };

  const error = (text) => {
    messageApi.open({
      type: 'error',
      content: text,
      duration: 0,
    });
  };

  useEffect(() => {
    liff
      .init({
        liffId: CURRENT_ENV.LIFF_ID1,
      })
      .then(async () => {
        if (liff.isLoggedIn()) {
          liff
            .getProfile()
            .then((profile) => {
              setProfileLine(profile);
            })
            .catch((err) => {
              console.log("%cERROR LINEOA DETAIL", "color: red", err);
            });

          let code = "";

          if (liff.isInClient() && liff.state) {
            const params = new URLSearchParams(liff.state);
            code = params.get("gcode") || "";
          } else {
            const params = new URLSearchParams(window.location.search);
            code = params.get("gcode") || "";
          }
          setCode(code);

        } else {
          liff.login();
        }
      })
      .catch((err) => {
        console.log(
          "%cERROR LINEOA HEADER",
          "color: red",
          err.code,
          err.message
        );
      });
    return () => { };
  }, []);

  useEffect(() => {
    if (!code) {
      error("ไม่พบรหัส กรุณาติดต่อแอดมิน");
      return;
    }

    const fetchData = async () => {
      try {
        setLoading(true);

        const verifyResponse = await axios.get(
          `${CURRENT_ENV.API_BASE_URL1}?path=verify&gcode=${encodeURIComponent(code)}&t=${Date.now()}`,
          {
            maxRedirects: 2,
            headers: {
              'Content-Type': 'text/plain;charset=utf-8',
            }
          }
        );

        const responseBody = verifyResponse?.data;

        if (responseBody?.status === 200) {
          setCanPlay(responseBody.data?.value ?? false);
          setListRewards(responseBody.data?.rewards ?? []);
        } else {
          setCanPlay(false);
          error(`${responseBody?.message} [${code}]` || "ไม่สามารถตรวจสอบรหัสได้");
          setListRewards(responseBody?.data?.rewards ?? []);
        }

      } catch (err) {
        console.error("Fetch Error:", err);
        setCanPlay(false);
        error(`เกิดข้อผิดพลาด กรุณาติดต่อแอดมิน Error: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [code]);

  const randomRewards = async () => {
    try {
      setIsShaking(true);
      setRewards(null)
      setCanPlay(null)
      const response = await axios.get(`${CURRENT_ENV.API_BASE_URL1}?path=play&userId=${profileLine?.userId}&gcode=${code}&displayName=${profileLine?.displayName}&pictureUrl=${profileLine?.pictureUrl}`);
      if (response.data.status === 200) {
        fireFireworks();
        setRewards(response.data?.data?.value?.name);
        success(`ยินดีด้วยคุณได้รับ ${response.data?.data?.value?.name} 🎉`);

        liff
          .sendMessages([
            {
              "type": "flex",
              "altText": `ยินดีด้วยคุณได้รับรางวัล คลิกเพื่อดู`,
              "contents": {
                "type": "bubble",
                "hero": {
                  "type": "image",
                  "url": CURRENT_ENV.FLEX_IMAGE1,
                  "size": "full",
                  "aspectRatio": "20:13",
                  "aspectMode": "cover"
                },
                "body": {
                  "type": "box",
                  "layout": "vertical",
                  "contents": [
                    {
                      "type": "text",
                      "text": `🎁 สิทธิพิเศษตอบแทนสมาชิก`,
                      "weight": "bold",
                      "wrap": true,
                      "size": "md"
                    },
                    {
                      "type": "box",
                      "layout": "vertical",
                      "contents": [
                        {
                          "type": "text",
                          "text": `${response.data?.data?.value?.name}`,
                          "size": "md",
                          "weight": "bold",
                          "wrap": true
                        }
                      ]
                    },
                    {
                      "type": "box",
                      "layout": "vertical",
                      "contents": [
                        {
                          "type": "text",
                          "text": `📩 ทักแอดมินรับได้เลยค่ะ 😊`,
                          "size": "md",
                          "color": "#B3B3B3",
                          "wrap": true
                        }
                      ]
                    }
                  ]
                }
              }
            }
          ])
          .then(() => {
            success("ส่งรางวัลไปยังช่องแชทเรียบร้อยค่ะ 🎉");
          })
          .catch((err) => {
            error(`ขออภัย ไม่สามารถส่ง Flex Message ได้`);
          });
      } else {
        error(response.data?.message)
      }
    } catch (_) { }
    finally {
      setIsShaking(false)
      setLoading(false)
    }
  };

  const fireFireworks = () => {
    confetti({
      particleCount: 150,
      spread: 100,
      origin: { x: 0.5, y: 0.5 },
      colors: ["#ff0000", "#ffa500", "#ffff00", "#00ff00", "#00bfff", "#ff69b4"],
      zIndex: 9999,
    });

    setTimeout(() => {
      confetti({
        particleCount: 80,
        spread: 120,
        origin: { x: 0.5, y: 0.45 },
        zIndex: 9999,
      });
    }, 200);

  };

  return (
    <>
      {contextHolder}
      {
        loading ?
          <LoadingScreen />
          : null

      }
      <div>
        <div className="container app-bg">
          <div>
            <div>
              <h1 className="txt-title">สุ่มกาชาปอง 🎉<br />ลุ้นรางวัลใหญ่</h1>
            </div>
            <div style={{ padding: 15 }}>
              {
                canPlay == true ?
                  <img onClick={() => { randomRewards() }} src={game} alt="" className={`reward-image ${isShaking === true ? "shake" : ""}`} />
                  :
                  <img src={game} alt="" className={`reward-image-disabled ${isShaking === true ? "shake" : ""}`} style={{ opacity: 0.5, filter: "grayscale(100%)" }} />
              }
            </div>

            {
              rewards ?
                <div style={{ margin: 10, display: `flex`, justifyContent: `center`, alignItems: `center`, }}>
                  <div style={{ display: `flex`, flexDirection: `column`, backgroundColor: `#ffffff94`, borderRadius: 20, justifyContent: `center`, alignContent: `center`, overflow: `scroll`, padding: 5, fontSize: 18, fontWeight: `bold`, border: `3px solid #9bff15`, width: `80%`, textAlign: `center` }}>
                    คุณได้รับ : {rewards}
                    <div style={{ fontSize: 12 }}>
                      {new Date().toLocaleDateString('th-TH', { timeZone: 'Asia/Bangkok', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' })}น.

                    </div>
                  </div>
                </div>
                : null
            }

            {
              listRewards ?
                <div style={{ marginTop: 10 }}>
                  <div className="txt-title">ของรางวัล</div>
                  <div style={{ display: `flex`, justifyContent: `center`, padding: 10, overflow: `hidden`, }}>
                    <div style={{ display: `grid`, width: `100%` }}>
                      <div className="grid-container">
                        {
                          listRewards?.map((data, index) => (
                            <div key={index}>
                              <div style={{ display: `flex`, justifyContent: `flex-start`, alignItems: `center`, flexDirection: `column`, fontSize: 10, padding: `2px 2px`, gap: 5, height: `100%`, marginTop: 10 }}>
                                <img src={data?.image} alt="" style={{ width: 30 }} />
                                <div>
                                  {data?.name}
                                </div>
                              </div>
                            </div>
                          ))
                        }
                      </div>
                    </div>
                  </div>
                </div> : null
            }
          </div>
        </div>
      </div>
    </>
  );
}

export default Theme1Screen;
